import React, { useState, useEffect, useLayoutEffect } from 'react'
import axios from 'axios'
import { render } from 'react-dom'
import { persistStore, autoRehydrate } from 'redux-persist'
import { Provider } from 'react-redux'
import store, { history } from './store'
import { BrowserRouter, Switch,Router, Route, } from 'react-router-dom';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import Login from './components/Login'
import LoginRestore from './components/Password-restore'
import RestorePassword from './components/RestorePassword'
import SubscriptionManage from './components/User/SubscriptionManage'
import EmailVerificationSuccessPanel from './components/RegistrationForms/EmailVerificationSuccessPanel'
import Main from './components/Main'
import { connect } from 'react-redux'
import PrivateRoute from './components/PrivateRoute'

import Preloader from './components/Layout/Preloader'
import ErrorBoundary from './components/ErrorBoundary'
import { LanguageProvider } from './helpers/language';

import NoMatch from './components/noMatch'
import Search from './components/Search/index'
import Profile from './components/User/profile'
import Projects from './components/User/projects'
import ProjectDetails from './components/User/projectDetails'
import QueryHistory from './components/User/history'
import Subscription from './components/User/subscription'
import Registration from './components/RegistrationForms/Registration'
import UsersTable from './components/Admin/usersTable'
import UserPage from './components/Admin/userPage'
import PasswordUpdate from './components/passwordUpdate'
import Maintenance from './components/Layout/Maintenance'
import 'semantic-ui-css/semantic.min.css'
import 'react-notifications/lib/notifications.css';
import Intercom from 'react-intercom';
import SendVerificationEmail from './components/RegistrationForms/SendVerificationEmail'
import RegistrationEmbedded from './components/RegistrationForms/RegistrationEmbedded'

const App = (props) => {

  const [rehydrated, setRehydrated] = useState(false)

  useEffect(() => {
    persistStore(store, {}, () => {
      setRehydrated(true)
    });
  }, [])
  
  if(!rehydrated || props.auth.load)
  return (
    <div className="middle"> <Preloader /> </div>
  )  

  const isEmbedded = (window.location.pathname === "/registration_embedded");

  const user = {
    user_id: props.auth.user ? props.auth.user.id : null  ,
    email: props.auth.user ? props.auth.user.email : null,
    name: props.auth.user ? props.auth.user.name : null
  };

  return (
    <LanguageProvider>
      <ErrorBoundary>
        <BrowserRouter>
          <NotificationContainer />
          {(!isEmbedded) && <Intercom appID="wp9qiv6k" { ...user }/>}
          <Switch>
            <Route path="/maintenance" component={Maintenance} />
            <Route path="/registration" component={Registration} />
            <Route path="/registration_embedded" component={RegistrationEmbedded} />
            <Route path="/registration_july_2020" component={Registration} />
            <Route path="/restore" component={LoginRestore} />
            <Route path="/updatepassword" component={PasswordUpdate} />
            <Route path="/login" component={Login} /> 
            <Route path="/users/restore/:id/:token" component={RestorePassword} />
            <Route path="/users/subscription/:id/:token" component={SubscriptionManage} />
            <Route path="/users/verify/:id/:token" component={EmailVerificationSuccessPanel} />  
            <Route path="/verification_email" component={SendVerificationEmail} />
            <Main>
              <Switch>
                <Route exact path="/" component={Search} />
                <Route path="/profile" component={Profile} />
                <Route path="/queryhistory" component={QueryHistory} />
                <Route exact path="/projects" component={Projects} />
                <Route path="/projects/details" component={ProjectDetails} />
                <Route path='/subscription' component={Subscription} />
                <PrivateRoute path="/adminpage" component={UsersTable} />
                <PrivateRoute path='/edituser/:id' component={UserPage} />
                <PrivateRoute path='/createuser' component={UserPage} />
                <Route component={NoMatch} />
              </Switch>
            </Main>
            {/* </Route> */}
          </Switch>
        </BrowserRouter>
      </ErrorBoundary>
    </LanguageProvider>
  )
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  context: state.context
})


export default connect(mapStateToProps)(App)
